import { Children as e, isValidElement as t } from "react";
// src/design/breadcrumbs/@/utils/index.tsx
function n(n) {
	return e.toArray(n).filter(t);
}
export { n as getValidChildren };

//# sourceMappingURL=index.js.map